(() => {
 const scene=document.querySelector('.artwork'), cat=document.querySelector('.cat-target');
 if(!scene||!cat)return;
 const drawing=scene.querySelector('.drawing');
 const spinStyle=document.createElement('style');
 spinStyle.textContent=`.wheel-spin-overlay{position:absolute;inset:0;width:100%;height:100%;z-index:1;pointer-events:none}.wheel-spin-ring{transform-origin:0px 0px;animation:wheel-surface-spin 14s linear infinite}@keyframes wheel-surface-spin{to{transform:rotate(360deg)}}@media(prefers-reduced-motion:reduce){.wheel-spin-ring{animation:none}}`;
 drawing.append(spinStyle);
 const spin=document.createElementNS('http://www.w3.org/2000/svg','svg');
 spin.setAttribute('class','wheel-spin-overlay');spin.setAttribute('viewBox','0 0 896 600');spin.setAttribute('aria-hidden','true');
 spin.innerHTML='<g transform="translate(354 450) scale(1 .19)"><g class="wheel-spin-ring" fill="none" stroke="#ea292a" stroke-width="1.2" opacity=".55"><circle r="230" stroke-dasharray="38 94 12 70" vector-effect="non-scaling-stroke"/><path d="M-192 0h17 M0 192v-17 M136 -136l-12 12" vector-effect="non-scaling-stroke"/></g></g>';
 drawing.append(spin);
 let busy=false;
 function tempt(){
  if(busy)return;
  busy=true; scene.classList.add('tempted');cat.setAttribute('aria-pressed','true');
  setTimeout(()=>{scene.classList.remove('tempted');cat.setAttribute('aria-pressed','false');busy=false},2600);
 }
 cat.addEventListener('pointerenter',e=>{if(e.pointerType==='mouse')tempt()});
 cat.addEventListener('click',tempt);
 cat.addEventListener('focus',tempt);
})();
